import { useQueryClient } from "@tanstack/react-query";
import { 
  useListCmsSections,
  useGetCmsSection,
  useUpsertCmsSection,
  getListCmsSectionsQueryKey
} from "@workspace/api-client-react";

export function useCmsSections() {
  return useListCmsSections();
}

export function useCmsSection(key: string) {
  return useGetCmsSection(key);
}

export function useCreateOrUpdateCmsSection() {
  const queryClient = useQueryClient();
  return useUpsertCmsSection({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getListCmsSectionsQueryKey() });
      }
    }
  });
}
